import { put, takeEvery } from 'redux-saga/effects';

import { apiCall, ApiResult } from 'Modules/core/api';
import { ActionPayload } from 'Modules/core/redux';
import { messagingActions } from 'Modules/core/messaging';

import { documentsActions } from './actions';
import { documents } from '../../api';
import { GetDocs } from './types';


function* getDocs({ $payload: { group } }: ActionPayload<GetDocs>) {
    try {
        yield put(documentsActions.setLoading({ group, isLoading: true }));
        yield put(documentsActions.setError({ group, error: null }));

        const data: ApiResult<typeof documents.list> = yield apiCall(
            documents.list,
            {
                query: {
                    group,
                },
            } as Parameters<typeof documents.list>[0],
        );

        yield put(documentsActions.setDocs({ group, data }));
    } catch (error) {
        yield put(documentsActions.setError({ group, error }));
        yield put(messagingActions.showNotification({
            content: {
                key: 'documents.getDocsError',
                values: {
                    error,
                },
            },
        }));
    } finally {
        yield put(documentsActions.setLoading({ group, isLoading: false }));
    }
}

export const sagas = [
    takeEvery(`${documentsActions.getDocs}`, getDocs),
];
